<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Brand logo-->
      <b-link class="brand-logo">
        <b-img
           style="width: 150px"
          :src="appDarkLogo"
          alt="logo"
        />
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img
            fluid
            :src="imgUrl"
            alt="Forgot password V2"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Forgot password-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title
            title-tag="h2"
            class="font-weight-bold mb-1"
          >
            Forgot Password? 🔒
          </b-card-title>
          <b-card-text class="mb-2">
            Enter your email and we'll send you instructions to reset your password
          </b-card-text>

          <!-- form -->
          <validation-observer ref="simpleRules">
            <b-form
              class="auth-forgot-password-form mt-2"
              @submit.prevent="validationForm"
            >
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  rules="required|email"
                >
                <label class="required-l" for="forgot-password-email">Email</label>
                  <b-form-input
                    id="forgot-password-email"
                    v-model="userEmail"
                    :state="errors.length > 0 ? false:null"
                    name="forgot-password-email"
                    placeholder="email@mail.com"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-button
                type="submit"
                v-ripple.400
                variant="primary"
                block
              >
                Send reset link
              </b-button>
            </b-form>
          </validation-observer>

          <p class="text-center mt-2">
            <b-link :to="{name:'auth-login'}">
              <feather-icon icon="ChevronLeftIcon" /> Back to login
            </b-link>
          </p>
        </b-col>
      </b-col>
      <!-- /Forgot password-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow, BCol, BLink, BCardTitle, BCardText, BImg, BForm, BFormGroup, BFormInput, BButton,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import store from '@/store/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { $themeConfig } from '@themeConfig'

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BImg,
    BForm,
    BButton,
    BFormGroup,
    BFormInput,
    BCardTitle,
    BCardText,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      userEmail: '',
      sideImg: require('@/assets/images/pages/forgot-password-v2.svg'),
      // validation
      required,
      email,
    }
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/forgot-password-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  methods: {
    validationForm() {
      const self = this
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.$http.post('/forgot-password', { email: self.userEmail })
            .then(res => {
              if (res.data.status) {
                this.userEmail = ''
                this.$refs.simpleRules.reset()
                // this.$toast({
                //   component: ToastificationContent,
                //   props: {
                //     title: 'Password Reset Link Sent',
                //     icon: 'BellIcon',
                //     text: 'We have emailed your password reset link!',
                //     variant: 'success',
                //   },
                // })

                this.$toast({
              component: ToastificationContent,
              props: {
                title: "Password Reset Link Sent",
                icon: 'BellIcon',
                variant: 'success',
                text: 'We have emailed your password reset link!',
              },
            }, {
              timeout: 3000, 
              position: 'bottom-center',
              toastClassName:"radius-8 successful-info",
              hideProgressBar : true,
            });
              } else {
                // this.$toast({
                //   component: ToastificationContent,
                //   props: {
                //     title: 'Password Reset Link sending failed',
                //     icon: 'BellIcon',
                //     text: res.data.message,
                //     variant: 'danger',
                //   },
                // })

                this.$toast({
        component: ToastificationContent,
        props: {
          title: "Password Reset Link sending failed",
          icon: 'BellIcon',
          variant: 'danger',
          text: res.data.message,
        },
      }, {
        timeout: 2000, 
        position: 'bottom-center',
        toastClassName:"radius-8 error-info ",
        hideProgressBar : true,
      });
              }
            })
            .catch(error => {
              // Do something on error
              if (error.response.status === 422) {
                if (typeof error.response.data.errors !== 'undefined') {
                  const keys = Object.keys(error.response.data.errors)
                  const values = Object.values(error.response.data.errors)
                  for (let i = 0; i <= keys.length; i += 1) {
                    if (error.response.data.errors.hasOwnProperty.call(values, i)) {
                      // this.$toast({
                      //   component: ToastificationContent,
                      //   props: {
                      //     title: 'Password Reset Link sending failed',
                      //     icon: 'BellIcon',
                      //     text: values[0][0],
                      //     variant: 'danger',
                      //   },
                      // })

                      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Password Reset Link sending failed",
          icon: 'BellIcon',
          variant: 'danger',
          text: values[0][0],
        },
      }, {
        timeout: 2000, 
        position: 'bottom-center',
        toastClassName:"radius-8 error-info ",
        hideProgressBar : true,
      });
                    }
                  }
                }
              } else {
                // this.$toast({
                //   component: ToastificationContent,
                //   props: {
                //     title: 'Password Reset Link sending failed',
                //     icon: 'BellIcon',
                //     text: 'Oops! Something Went Wrong',
                //     variant: 'danger',
                //   },
                // })

                   
                this.$toast({
        component: ToastificationContent,
        props: {
          title: "Password Reset Link sending failed",
          icon: 'BellIcon',
          variant: 'danger',
          text: 'Oops! Something Went Wrong',
        },
      }, {
        timeout: 2000, 
        position: 'bottom-center',
        toastClassName:"radius-8 error-info ",
        hideProgressBar : true,
      });
              }
            })
        }
      })
    },
  },
  setup() {
    // App Name
    const { appName, appDarkLogo } = $themeConfig.app
    return {
      appName,
      appDarkLogo,
    }
  },
}
</script>

<style lang="scss">
    @import '@core/scss/vue/pages/page-auth.scss';
    .brand-text{
        line-height: 42px;
        margin-bottom: 0;
    }
</style>
